import { useEffect, useRef } from 'react'
import { Icon } from 'components/ui/Icon'
import { ModalUploadManager } from '../managers/modal/modal-upload-manager'
import { WidgetFileUploadPreview } from 'components/WidgetFileUploadPreview'

export type WidgetFileUploadProps = {
  files: File[]
  onFilesAdded: (files: File[]) => void
  onFilesRemoved: (index: number) => void
  clearFiles: () => void
  disable?: boolean
}

export const WidgetFileUpload = ({
  onFilesRemoved,
  onFilesAdded,
  files,
  clearFiles,
  disable,
}: WidgetFileUploadProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null)

  const handleButtonClick = () => {
    inputFileRef.current?.click()
  }

  useEffect(() => {
    if (files.length === 0) {
      ModalUploadManager.hide()
    } else {
      showFileModal()
    }
  }, [files])

  const showFileModal = () => {
    ModalUploadManager.show({
      children: (
        <div className={'tw-flex tw-flex-row tw-gap-2 tw-flex-wrap'}>
          {files.map((__, index) => {
            return <WidgetFileUploadPreview key={index} onClickDelete={() => onFilesRemoved(index)} />
          })}
        </div>
      ),
      onClose: () => clearFiles(),
    })
  }

  return (
    <div className={'tw-ml-2'}>
      <input
        type="file"
        ref={inputFileRef}
        multiple={true}
        disabled={disable}
        onChange={({ target: { files: newFiles } }) => {
          if (newFiles) {
            onFilesAdded(Array.from(newFiles))
          }
        }}
        style={{ display: 'none' }}
      />
      <button
        type="submit"
        className={`tw-hover:bg-slate-100 tw-inline-flex tw-justify-center tw-rounded-full tw-p-2 tw-text-white`}
        disabled={disable}
        onClick={handleButtonClick}
      >
        <Icon icon={['fas', 'plus']} className="tw-h-5 tw-w-5 tw-stroke-[1.1px]" />
      </button>
    </div>
  )
}
